import { convertPropertiesToShapeProperties } from '../../utilities/convertPropertiesToShapeProperties';
import { updateGroups } from '../../Helpers/helpers';

const updateProperties = (canvasState, command, ids = null) => {
    const updates = convertPropertiesToShapeProperties(command.get('properties'));
    return updateGroups(canvasState, updates, ids);
};

export default updateProperties;
